/* Dependencies */
import svg4everybody from 'svg4everybody';

// Modules
import { accordionInit } from './Modules/Accordion/Accordion';
import { articleInit } from './Modules/Article/Article';
import { producerCarouselInit } from './Modules/ProducerCarousel/ProducerCarousel';
import { producersLoadMoreInit } from './Modules/ProducersLoadMore/ProducersLoadMore';
import { coffeePickerInit } from './Widgets/CoffeePicker/CoffeePicker';
import { productInit } from './Modules/Product/Product';
import { productCarouselInit } from './Modules/ProductCarousel/ProductCarousel';
import { megaMenuDesktopInit } from './Modules/MegaMenuDesktop/MegaMenuDesktop';
import { megaMenuSearchInit } from './Modules/MegaMenuSearch/MegaMenuSearch';
import { megaMenuMobileInit } from './Modules/MegaMenuMobile/MegaMenuMobile';
import { ModalVideoBlockInit } from './Modules/ModalVideoBlock/ModalVideoBlock';
import { findYourFlavorInit } from './Modules/FindYourFlavor/FindYourFlavor';
import { bindProductWidgets } from './Modules/ProductWidget/ProductWidget';
import { recommendedProductsInit } from './Modules/ProductRecomendations/ProductRecomendations';
import { splitImageListFeatureInit } from './Modules/SplitImageListFeature/SplitImageListFeature';
import { subscriptionBuilderInit } from './Modules/SubscriptionBuilder/SubscriptionBuilder';
import { onboardingInit } from './Modules/Onboarding/OnBoarding';
import { accountAddressesInit } from './Modules/AccountAddress/AccountAddress';

// Utils
import { scrollHelperInit } from './Utils/ScrollHelper/ScrollHelper';
import './Utils/Shopify/Shopify';

// Helpers
import { setHeightVariable } from './helpers/setHeightVariable/setHeightVariable';
import { setFooterUrlTargets } from './helpers/setFooterUrlTargets/setFooterUrlTargets';
import { shippingBarInit } from './helpers/shippingBar/shippingBar';
import { handleShopifyLoad } from './helpers/handleShopifyLoad/handleShopifyLoad';

/**
 * Activate modules when content load event fires.
 */
document.addEventListener('DOMContentLoaded', () => {
  // Packages
  svg4everybody();

  // Helpers
  setHeightVariable();
  setFooterUrlTargets();
  shippingBarInit();
  handleShopifyLoad();

  // Modules
  accordionInit();
  accountAddressesInit();
  articleInit();
  bindProductWidgets();
  producerCarouselInit();
  producersLoadMoreInit();
  coffeePickerInit();
  findYourFlavorInit();
  productInit();
  productCarouselInit();
  megaMenuDesktopInit();
  megaMenuMobileInit();
  megaMenuSearchInit();
  ModalVideoBlockInit();
  onboardingInit();
  recommendedProductsInit();
  subscriptionBuilderInit();
  splitImageListFeatureInit();

  // Utils
  scrollHelperInit();
});
